import React, { useEffect, useState } from "react";
import PopModal from "../../Constant/Custom/Models/PopModal";
import Loader from "../../Constant/Custom/Loader";
import axios from "axios";
import { serverUrl } from "../../Constant/Static/config";

const CvStatus = ({ studentData, handlePrev, handleNext }) => {
  const [status, setStatus] = useState("");
  const [comment, setComment] = useState("");
  const [csrfToken, setCsrfToken] = useState("");

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalType, setModalType] = useState({ title: "", text: "", icon: "" });
  const [onConfirm, setOnConfirm] = useState(() => () => { });
  const [onCancel, setOnCancel] = useState(() => () => { });
  const [showCancelButton, setShowCancelButton] = useState(false);

  const [isLoading, setIsLoading] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    //console.log(name, " ", value);

    if (name === "status") {
      setComment("");
      setStatus(value);
    }
    else if (name === "comment") {
      setComment(value);
    }
  };

  const updateStatus = async () => {
    //console.log("update status");
    // if(status==="V"){
    //     setComment("");
    // }
    //console.log("comment", comment);

    const userData = studentData;
    try {
      setIsLoading(true)
      const response = await axios.post(
        `${serverUrl}/api/cv/updateAppStatus`,
        {
          appNo: userData.APPLN_NO,
          mobile:userData.MOBILE,
          status: status,
          comment: comment
        },
        {
          headers: {
            "CSRF-Token": csrfToken,
          },
          withCredentials: true,
        }
      );
      //console.log("success", response.data);
      if (response.status === 200) {
        setModalType({
          icon: "success",
          title: "Success",
          text: `Status Updated Sucessfully`,
        });
        openModal();
        setOnConfirm(() => handleNext);
        setShowCancelButton(false);
      }
    } catch (err) {
      setModalType({
        icon: "error",
        title: "Failed",
        text: `Update Status Failed`,
      });
      openModal();
      setOnConfirm(() => closeModal);
      setShowCancelButton(false);
    }
    finally {
      setIsLoading(false)
    }
  };

  const handleSubmit = () => {
    let stats = "";

    if (status === "W") {
      stats = "Waiting List";
    } else if (status === "E") {
      stats = "Not Eligible";
    } else if (status === "V") {
      stats = "Verified";
    }
    if ((status === "W" || status === "E") && comment.trim() === "") {
      setModalType({
        icon: "warning",
        title: "warning",
        text: `Comment cannot be empty for ${stats}`,
      });
      openModal();
      setOnConfirm(() => closeModal);
      setShowCancelButton(false);
    }
    else {
      setModalType({
        icon: "info",
        title: "Confirmation",
        text: `Are you sure to make the student ${stats}`,
      });
      openModal();
      setOnConfirm(() => updateStatus);
      setShowCancelButton(true);
      setOnCancel(() => closeModal);
    }

  };
  useEffect(() => {
    //console.log(isLoading);

    const fetchCsrfToken = async () => {
      try {
        const response = await axios.get(`${serverUrl}/api/csrf-token`, {
          withCredentials: true, // Ensure cookies are sent
        });
        setCsrfToken(response.data.csrfToken); // Set CSRF token
      } catch (error) {
        console.error("Error fetching CSRF token:", error);
      }
    };

    fetchCsrfToken();
  }, []);

  if (isLoading) {
    return <Loader />
  }

  return (
    <section>
      <div>
        <h2 style={{ textAlign: 'center', marginTop: '40px' }}>Kindly update the status of the Applicant </h2>
      </div>
      <div className="cv-status-content">
        <div class="cv-status-group">
          <input
            type="radio"
            name="status"
            value="W"
            onChange={handleChange}
            checked={status === "W"}
            id="Waiting-List"
            class="cv-status-btn"
          />
          <label for="Waiting-List" class="cv-status-label">
            Waiting List
          </label>

          <input
            type="radio"
            name="status"
            value="V"
            onChange={handleChange}
            checked={status === "V"}
            id="Verified"
            class="cv-status-btn"
          />
          <label for="Verified" class="cv-status-label">
            Verified
          </label>

          <input
            type="radio"
            name="status"
            value="E"
            onChange={handleChange}
            checked={status === "E"}
            id="Not-Eligible"
            class="cv-status-btn"
          />
          <label for="Not-Eligible" class="cv-status-label">
            Not Eligible
          </label>
        </div>
      </div>
      {(status === "W" || status === "E") && (<div className="cv-comment">
        <label className="cv-comment-label"><h2>Comment :</h2> </label><br></br>
        {/* <input className="cv-comment-inp" type="text"></input> */}
        <textarea name="comment" value={comment} className="cv-comment-inp" onChange={handleChange} ></textarea>
      </div>)}

      <div className="next-button">
        <button className="log-btn button button-secondary" onClick={handlePrev}>
          Previous
        </button>
        <button className="log-btn button button-primary" disabled={status === ""} onClick={handleSubmit}>
          Update Status
        </button>
      </div>
      <div
        style={{
          position: "relative",
          alignSelf: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <PopModal
          isOpen={isModalOpen}
          type={modalType}
          confirmButtonText="OK"
          cancelButtonText="Cancel"
          showCancelButton={showCancelButton}
          onConfirm={onConfirm}
          onCancel={onCancel}
        />
      </div>
    </section>
  );
};

export default CvStatus;